import { RouteConfig } from "vue-router";
import { ServersCode } from "@/config/servers-code.config";

const routes: Array<RouteConfig> = [
  // Root
  {
    path: "/root",
    meta: {
      layout: "main",
      auth: true,
      name: "Root",
    },
    component: () => import("../../views/main/Root.vue"),
    children: [
      {
        path: "/weather",
        name: "Weather",
        meta: {
          code: null,
        },
        component: () => import("../../views/main/root/RootWeather.vue"),
      },
      {
        path: "/root-config",
        name: "RootConfig",
        meta: {
          code: null,
        },
        component: () => import("../../views/main/root/RootConfig.vue"),
      },
      {
        path: "/root-settings",
        name: "RootSettings",
        meta: {
          code: null,
        },
        component: () => import("../../views/main/root/RootSettings.vue"),
      },
      {
        path: "/filoxenia-instruction",
        name: "Instruction",
        meta: {
          code: null,
        },
        component: () => import("../../views/main/root/Instruction.vue"),
      },
    ],
  },
  // Home
  {
    path: "/",
    name: "Home",
    meta: {
      layout: "main",
      auth: true,
      code: "0",
    },
    component: () => import("../../views/Home.vue"),
  },
  // Administration
  {
    path: "/administration",
    meta: {
      layout: "main",
      auth: true,
      name: "Administration",
    },
    component: () => import("../../views/main/Administration.vue"),
    children: [
      {
        path: "servers",
        name: "AdministrationServers",
        meta: {
          code: ServersCode.getUsers,
        },
        component: () =>
          import("../../views/main/administration/AdministrationServers.vue"),
      },
      {
        path: "telemetry",
        name: "AdministrationTelemetry",
        meta: {
          code: ServersCode.getUsers,
        },
        component: () =>
          import("../../views/main/administration/AdministrationTelemetry.vue"),
      },
      {
        path: "config",
        name: "FiloxeniaConfiguration",
        meta: {
          code: ServersCode.getFiloxeniaConfiguration,
        },
        component: () =>
          import("../../views/main/administration/FiloxeniaConfiguration.vue"),
      },
      {
        path: "users",
        name: "AdministrationUsers",
        meta: {
          code: ServersCode.getUsers,
        },
        component: () =>
          import("../../views/main/administration/AdministrationUsers.vue"),
      },
    ],
  },
  // Hotel
  {
    path: "/hotel",
    meta: {
      layout: "main",
      auth: true,
      name: "Hotel",
    },
    component: () => import("../../views/main/HotelPage.vue"),
    children: [
      {
        path: "staff",
        name: "StaffPage",
        meta: {
          code: ServersCode.getStaffList,
        },
        component: () => import("../../views/main/administration/Staff.vue"),
      },
      {
        path: "hotel",
        name: "HotelAdministration",
        meta: {
          code: ServersCode.getRoomList,
        },
        component: () =>
          import("../../views/main/hotel/HotelAdministration.vue"),
      },
      {
        path: "guests",
        name: "GuestList",
        meta: {
          layout: "dashboard",
          code: ServersCode.getGuests,
        },
        component: () => import("../../views/main/hotel/GuestRegistration.vue"),
      },
      {
        path: "restorants",
        name: "RestorantsConstructior",
        meta: {
          code: ServersCode.getGuests, // TODO code
        },
        component: () =>
          import("../../views/main/hotel/RestorantsConstructior.vue"),
      },
    ],
  },
  // Hotel Info
  {
    path: "/information",
    meta: {
      layout: "main",
      auth: true,
      name: "HotelInfo",
    },
    component: () => import("../../views/main/HotelInfo.vue"),
    children: [
      {
        path: "",
        name: "HotelInfoList",
        meta: {
          code: ServersCode.getAllHotelInfos,
        },
        component: () => import("../../views/main/info/HotelInfoList.vue"),
      },
      {
        path: "add-info",
        name: "HotelInfoAdd",
        props: true,
        meta: {
          code: ServersCode.addHotelInfo,
        },
        component: () => import("../../views/main/info/HotelInfoAdd.vue"),
      },
      {
        path: "recucler-info",
        name: "HotelInfoRecucker",
        props: true,
        meta: {
          code: ServersCode.restoreInfoFromRecycler,
        },
        component: () => import("../../views/main/info/HotelInfoRecucker.vue"),
      },
      {
        path: "info-history",
        name: "HotelInfoHistory",
        props: true,
        meta: {
          code: ServersCode.getAllHotelInfos,
        },
        component: () => import("../../views/main/info/HotelInfoHistory.vue"),
      },
    ],
  },
  // Orders
  {
    path: "/orders",
    meta: {
      layout: "dashboard",
      auth: true,
      name: "OrderProcessing",
    },
    component: () => import("../../views/main/FKeeper.vue"),
    children: [
      {
        path: "menu",
        name: "Menu",
        meta: {
          code: ServersCode.getMenu,
          layout: "dashboard",
        },
        component: () => import("../../views/main/orders/BarOrders.vue"),
      },
      {
        path: "excursion",
        name: "Excursion",
        meta: {
          code: ServersCode.getAllExcursions,
          layout: "dashboard",
        },
        component: () => import("../../views/main/orders/ExcursionOrders.vue"),
      },
      {
        path: "gallery",
        name: "Gallery",
        meta: {
          code: ServersCode.getAllGallery,
          layout: "dashboard",
        },
        component: () => import("../../views/main/orders/GalleryOrders.vue"),
      },
    ],
  },
  // Room Service Requests
  {
    path: "/room-service",
    name: "RoomService",
    meta: {
      layout: "main",
      auth: true,
      code: ServersCode.getRoomServiceRequests,
    },
    component: () => import("../../views/main/RoomServicePage.vue"),
  },
  // Timetable
  {
    path: "/timetable",
    name: "Timetable",
    meta: {
      layout: "main",
      auth: true,
      code: ServersCode.getTimetableFiles,
    },
    component: () => import("../../views/main/TimetablePage.vue"),
  },
  // Instructions (sections with docs)
  {
    path: "/instructions",
    name: "Instructions",
    meta: {
      layout: "main",
      auth: true,
      code: ServersCode.getSections,
    },
    component: () => import("../../views/main/InstructionsPage.vue"),
  },
  // RouterInfoPage
  {
    path: "/routes",
    meta: {
      layout: "main",
      auth: true,
      name: "RouterInfoPage",
    },
    component: () => import("../../views/main/RouterInfoPage.vue"),
    children: [
      {
        path: "",
        name: "RouteList",
        meta: {
          code: ServersCode.getAllRoutes,
        },
        component: () => import("../../views/main/route_info/RouteList.vue"),
      },
      {
        path: "add-route",
        name: "AddRoute",
        props: true,
        meta: {
          code: ServersCode.addNewRoute,
        },
        component: () => import("../../views/main/route_info/AddRoute.vue"),
      },
      {
        path: "/citys",
        name: "CityList",
        meta: {
          code: ServersCode.getAllCitysRouteInfo,
        },
        component: () => import("../../views/main/route_info/CityList.vue"),
      },
      {
        path: "/add-city",
        name: "AddRouteCity",
        meta: {
          code: ServersCode.addNewCity,
        },
        component: () => import("../../views/main/route_info/AddRouteCity.vue"),
      },
      {
        path: "/recucler-city",
        name: "RecuclerCityList",
        props: true,
        meta: {
          code: ServersCode.restoreCityById,
        },
        component: () =>
          import("../../views/main/route_info/RecuclerCityList.vue"),
      },
    ],
  },
  // RouterInfoPage v2
  {
    path: "/routes-v2",
    name: "RouteInfoV2Page",
    meta: {
      layout: "main",
      auth: true,
      code: ServersCode.getAllRoutes,
    },
    component: () => import("../../views/main/RouteInfoV2Page.vue"),
  },
  // CruiseOffers
  {
    path: "/cruises",
    name: "CruiseOffers",
    meta: {
      layout: "main",
      auth: true,
      code: ServersCode.GetAllCruises,
    },
    component: () => import("../../views/main/CruiseOffers.vue"),
  },
  // WikiPage
  {
    path: "/wiki",
    meta: {
      layout: "main",
      auth: true,
      name: "WikiMapPage",
    },
    component: () => import("../../views/main/WikiMapPage.vue"),
    children: [
      {
        path: "",
        name: "WikiList",
        meta: {
          code: ServersCode.getAllWikiObjects,
        },
        component: () => import("../../views/main/wiki/WikiList.vue"),
      },
      {
        path: "/wiki-history",
        name: "WikiHistory",
        props: true,
        meta: {
          code: ServersCode.updateWikiObjectById,
        },
        component: () => import("../../views/main/wiki/WikiHistory.vue"),
      },
    ],
  },
  // Menu
  {
    path: "/menu",
    meta: {
      layout: "main",
      auth: true,
      name: "MenuPage",
    },
    component: () => import("../../views/main/MenuPage.vue"),
    children: [
      {
        path: "/",
        name: "MenuList",
        meta: {
          code: ServersCode.getMenu,
        },
        component: () => import("../../views/main/menu/MeniList.vue"),
      },
      {
        path: "change-dish",
        name: "ChangeDish",
        props: true,
        meta: {
          code: ServersCode.updateMenuItem,
        },
        component: () => import("../../views/main/menu/ChangeDish.vue"),
      },
      {
        path: "recycler-menu",
        name: "RecyclerMenuList",
        props: true,
        meta: {
          code: ServersCode.restoreMenuItemById,
        },
        component: () => import("../../views/main/menu/RecyclerMenuList.vue"),
      },
      {
        path: "bar/recucler",
        name: "MenuBarsRecucler",
        meta: {
          code: ServersCode.getBars,
        },
        component: () => import("../../views/main/menu/MenuBarsRecucler.vue"),
      },
      {
        path: "bar-list",
        name: "BarList",
        meta: {
          code: ServersCode.getBars,
        },
        component: () => import("../../views/main/menu/MenuBars.vue"),
      },
    ],
  },
  // ComplexMenu
  {
    path: "/complex-menu",
    name: "ComplexMenu",
    meta: {
      layout: "main",
      auth: false,
      code: null,
    },
    component: () => import("../../views/main/menu/ComplexMenu.vue"),
  },
  {
    path: "/complex-menu/recucler",
    name: "ComplexMenuRecucler",
    meta: {
      layout: "main",
      auth: false,
      code: null,
    },
    component: () => import("../../views/main/menu/ComplexMenuRecucler.vue"),
  },
  // ExcursionPage
  {
    path: "/excursions",
    name: "ExcursionList",
    meta: {
      layout: "main",
      auth: true,
      code: ServersCode.getAllExcursions,
    },
    component: () => import("../../views/main/ExcursionsPage.vue"),
  },

  // ChannelsPage
  {
    path: "/channels",
    meta: {
      layout: "main",
      auth: true,
      name: "ChannelsPage",
    },
    component: () => import("../../views/main/ChannelsPage.vue"),
    children: [
      {
        path: "",
        name: "ChannelsList",
        meta: {
          code: ServersCode.getChannels,
        },
        component: () => import("../../views/main/channels/ChannelsList.vue"),
      },
    ],
  },
  // Audio Page
  // {
  //   path: "/audio",
  //   meta: {
  //     layout: "main",
  //     auth: true,
  //     code: ServersCode.getAudioSongs,
  //     name: "Audio",
  //   },
  //   children: [
  //     {
  //       path: "list",
  //       name: "AudioList",
  //       meta: {
  //         code: ServersCode.getAudioSongs,
  //       },
  //       component: () => import("../../views/main/audio/AudioList.vue"),
  //     },
  //     {
  //       path: "add-audio",
  //       name: "AudioAdd",
  //       props: true,
  //       meta: {
  //         code: ServersCode.AddAudioSong,
  //       },
  //       component: () => import("../../views/main/audio/AudioAdd.vue"),
  //     },
  //     {
  //       path: "categotys",
  //       name: "AudioCategotys",
  //       props: true,
  //       meta: {
  //         code: ServersCode.AddAudioCategory || ServersCode.updateAudioCategory,
  //       },
  //       component: () => import("../../views/main/audio/AudioCategotys.vue"),
  //     },
  //     {
  //       path: "categoty-recucler",
  //       name: "AudioCategotysRecucler",
  //       props: true,
  //       meta: {
  //         code: ServersCode.restoreCinemaCategoryById, // TODO code
  //       },
  //       component: () =>
  //         import("../../views/main/audio/AudioCategotysRecucler.vue"),
  //     },
  //     {
  //       path: "genrys",
  //       name: "AudioGenrys",
  //       props: true,
  //       meta: {
  //         code:
  //           ServersCode.addCinemaCategory ||
  //           ServersCode.updateCinemaCategoryById, // TODO code
  //       },
  //       component: () => import("../../views/main/audio/AudioGenrys.vue"),
  //     },
  //     {
  //       path: "genrys-recucler",
  //       name: "AudioGenrysRecucler",
  //       props: true,
  //       meta: {
  //         code: ServersCode.restoreCinemaCategoryById, // TODO code
  //       },
  //       component: () =>
  //         import("../../views/main/audio/AudioGenrysRecucler.vue"),
  //     },
  //     {
  //       path: "singers",
  //       name: "AudioSingers",
  //       props: true,
  //       meta: {
  //         code:
  //           ServersCode.addCinemaCategory ||
  //           ServersCode.updateCinemaCategoryById, // TODO code
  //       },
  //       component: () => import("../../views/main/audio/AudioSingers.vue"),
  //     },
  //     {
  //       path: "singers-recucler",
  //       name: "AudioSingersRecucler",
  //       props: true,
  //       meta: {
  //         code: ServersCode.restoreCinemaCategoryById, // TODO code
  //       },
  //       component: () =>
  //         import("../../views/main/audio/AudioSingersRecucler.vue"),
  //     },
  //   ],
  //   component: () => import("../../views/main/AudioPage.vue"),
  // },
  // Audio FTP Page
  {
    path: "/audio-fs",
    name: "AudioFTP",
    meta: {
      layout: "main",
      auth: true,
      code: ServersCode.addFSAudio,
    },
    component: () => import("../../views/main/AudioFTPPage.vue"),
  },
  // Music Page
  {
    path: "/audio",
    meta: {
      layout: "main",
      auth: true,
      name: "Audio",
    },
    component: () => import("../../views/main/MusicPage.vue"),
    children: [
      {
        path: "",
        name: "AudioList",
        meta: {
          code: ServersCode.addFSAudio,
        },
        component: () => import("../../views/main/music/PlaylistsPage.vue"),
      },
      {
        path: "playlist",
        name: "AudioPlaylist",
        meta: {
          code: ServersCode.addFSAudio,
        },
        component: () =>
          import("../../views/main/music/PlaylistDetailPage.vue"),
      },
    ],
  },
  // Audiobooks Page
  {
    path: "/audiobooks",
    meta: {
      layout: "main",
      auth: true,
      name: "Audiobooks",
    },
    component: () => import("../../views/main/AudiobooksPage.vue"),
    children: [
      {
        path: "",
        name: "AudiobooksList",
        meta: {
          code: ServersCode.getAudiobooks,
        },
        component: () =>
          import("../../views/main/audiobooks/AudiobooksListPage.vue"),
      },
      {
        path: "detail",
        name: "AudiobookDetail",
        meta: {
          code: ServersCode.addAudiobook,
        },
        component: () =>
          import("../../views/main/audiobooks/AudiobookDetailPage.vue"),
      },
    ],
  },
  // Cinema Page
  {
    path: "/cinema",
    meta: {
      layout: "main",
      auth: true,
      code: ServersCode.getAllFilms,
      name: "Cinema",
    },
    children: [
      {
        path: "list",
        name: "CinemaList",
        meta: {
          code: ServersCode.getAllFilms,
        },
        component: () => import("../../views/main/cinema/CinemaList.vue"),
      },
    ],
    component: () => import("../../views/main/CinemaPage.vue"),
  },
  // painting mode
  {
    path: "/painting-mode",
    meta: {
      layout: "main",
      auth: true,
      code: ServersCode.getImageByName,
      name: "PaintingModePage",
    },
    children: [
      {
        path: "list",
        name: "PaintingModeList",
        meta: {
          // code: ServersCode.getImageByName,
          code: null,
        },
        component: () =>
          import("../../views/main/painting-mode/PaintingModeList.vue"),
      },
    ],
    component: () => import("../../views/main/PaintingModePage.vue"),
  },
  // GaleryPage
  {
    path: "/gallery",
    meta: {
      layout: "main",
      auth: true,
      code: ServersCode.getAllGallery,
      name: "GalleryPage",
    },
    children: [
      {
        path: "ftp",
        name: "GalleryFTP",
        meta: {
          code: ServersCode.getGalleryFTP,
        },
        component: () => import("../../views/main/gallary/GalleryFTP.vue"),
      },
      {
        path: "list",
        name: "GalleryList",
        meta: {
          code: ServersCode.getAllGallery,
        },
        component: () => import("../../views/main/gallary/GalleryList.vue"),
      },
      {
        path: "formats",
        name: "GalleryFormats",
        props: true,
        meta: {
          code: ServersCode.addGallery,
        },
        component: () => import("../../views/main/gallary/GalleryFormats.vue"),
      },
      {
        path: "folders/recucler",
        name: "GalleryFoldersRecucler",
        meta: {
          code: ServersCode.forceDeleteGalleryById,
        },
        component: () => import("../../views/main/gallary/FoldersRecucler.vue"),
      },
      {
        path: "formats/recurler",
        name: "FormatsGellaryRecucler",
        meta: {
          code: ServersCode.forceDeleteGalleryFormatById,
        },
        component: () =>
          import("../../views/main/gallary/FormatsGellaryRecucler.vue"),
      },
    ],
    component: () => import("../../views/main/GalleryPage.vue"),
  },
  // SIGN
  {
    path: "/sign",
    meta: {
      layout: "main",
      auth: true,
      name: "MailSignPage",
    },
    component: () => import("../../views/main/sign/MailSignPage.vue"),
    children: [
      {
        path: "",
        name: "Sign",
        meta: {
          code: ServersCode.getAllHotelInfos,
        },
        component: () => import("../../views/main/sign/Sign.vue"),
      },
    ],
  },
  // Support
  {
    path: "/support",
    name: "Support",
    meta: {
      layout: "main",
      auth: true,
      code: "0",
    },
    component: () => import("../../views/Support.vue"),
  },
  // FAQ
  {
    path: "/faq",
    name: "FAQ",
    meta: {
      layout: "main",
      auth: true,
      code: "0",
    },
    component: () => import("../../views/FAQ.vue"),
  },

  // Empty
  {
    path: "/login",
    name: "Login",
    meta: {
      layout: "empty",
      auth: false,
    },
    component: () => import("../../views/empty/login.vue"),
  },
  {
    path: "/forbidden",
    name: "403",
    meta: {
      layout: "main",
      auth: false,
    },
    component: () => import("../../views/Forbidden.vue"),
  },
  {
    path: "*",
    name: "404",
    meta: {
      layout: "main",
      auth: false,
    },
    component: () => import("../../views/Forbidden.vue"),
  },
];

export default routes;
